export enum Language {
  English = 'en',
  Hungarian = 'hu',
  Ukrainian = 'uk',
}
